export type LatLng = { lat: number; lng: number }
export type LatLngPerimeter = LatLng[]

export function checkLatLngIsWithinPerimeter(
  currentLatLng: LatLng,
  perimeterLatLng: LatLngPerimeter,
): boolean {
  let inside = false
  for (
    let i = 0, j = perimeterLatLng.length - 1;
    i < perimeterLatLng.length;
     
    j = i++
  ) {
    const xi = perimeterLatLng[i].lng
    const yi = perimeterLatLng[i].lat
    const xj = perimeterLatLng[j].lng
    const yj = perimeterLatLng[j].lat

    const intersect =
      yi > currentLatLng.lat !== yj > currentLatLng.lat &&
      currentLatLng.lng <
        ((xj - xi) * (currentLatLng.lat - yi)) / (yj - yi) + xi

    if (intersect) inside = !inside
  }

  return inside
}
